import { Navigate, useParams } from 'react-router-dom'

/**
 * An old per-wedding document address (/weddings/<id>/quotes/<quote>) sent on
 * to the document's own address (29 Oct 2026). "new" opens the New … form
 * with the wedding filled in.
 */
export function Forward({ to, param }: { to: 'quotes' | 'invoices'; param: string }) {
  const params = useParams()
  const id = params[param] ?? ''
  const jobId = params.jobId ?? ''
  return <Navigate replace to={id === 'new' ? `/${to}?new=${jobId}` : `/${to}/${id}`} />
}
